/**=========================================================
 * Module: app-number.js
 * Number visualization
 =========================================================*/

App.directive('appNumber', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/number.html',
      //controller: 'CounterController',
      restrict: 'E',
      replace: true,
      scope: { 
          value: '=value',
          prefix: '=prefix',
          suffix: '=suffix',
          numdecimals: '=numdecimals',
          defvalue: '=defvalue'
      }
  };

});
